import Home from 'pages/home';

export default function HomeScreen() {
  return <Home />;
}
